<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" class="bgImg" />
      <div>观展指南</div>
    </div>
    <div class="pdf-box">
      <img src="../../../static/images/index/pdf_bg.png" />
      <div>观展指南PDF</div>
    </div>
    <router-link :to="{path:'/pdfBox',query:{type:1}}" class="pdf-btn">点击查看</router-link>
    <!-- <mini-program path="/pkgguangya/pages/preregistration/preregistration" class="register">
      <span class="iconfont icon-dengjixinxi"></span>马上预登记
    </mini-program>
    <div class="tips">免排队，快速入场</div> -->
  </div>
</template>
<script>
import miniProgram from "@/components/miniProgram";
export default {
  name: "expoVisitGuide",
  components: {
    miniProgram,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="less">
.top-box {
  width: 375px;
  height: 103px;
  position: relative;
  div {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 23px;
    font-weight: bold;
  }
}

.bgImg {
  width: 100%;
  height: 100%;
}

.pdf-box {
  margin: 55px auto;
  width: 230px;
  height: 265px;
  background: #f4f4f4;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #000000;
  font-size: 25px;
  font-weight: bold;
  img {
    width: 115px;
    height: 115px;
    margin-bottom: 30px;
  }
}

.pdf-btn{
  display: block;
  margin: 22px auto 0;
  width: 230px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  background: #EB4D4E;
  border-radius: 22px;
  color: #ffffff;
  font-size: 18px;
}

// .register {
//   width: 230px;
//   height: 40px;
//   border: 1px solid #cccccc;
//   border-radius: 5px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: #000000;
//   font-size: 14px;
//   margin: 0 auto;
//   span {
//     margin-right: 11px;
//     font-size: 20px;
//     color: #666666;
//   }
// }

// .tips {
//   text-align: center;
//   color: #999999;
//   font-size: 10px;
//   margin-top: 6px;
//   padding-bottom: 20px;
// }
</style>

